import { defineAsyncComponent } from 'vue';
import hero from '@app/components/Blocks/hero.vue';
export default {
    /**
     * Registered block components
     */
    blocks: {
        'cms.hero': hero,
        'cms.accordion': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/accordion.vue')),
        'cms.simpleText1Col': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/simpleText.vue')),
        'cms.simpleText2Col': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/simpleText.vue')),
        'cms.simpleTextMultiCol': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/simpleTextMultiCol.vue')),
        'cms.simpleTextImage': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/simpleTextImage.vue')),
        'cms.tile': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/tile.vue')),
        'cms.form': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/contactForm.vue')),
        'cms.downloads': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/downloads.vue')),
        'cms.image': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/image.vue')),
        'cms.video': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Core" */ '@app/components/Blocks/video.vue')),
    },
    /**
     * Registered block group components
     */
    groups: {
    // hero: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-BlockGroups" */ '@app/components/BlockGroups/SliderGroup.vue')),
    },
    /**
     * Registers a new block component
     *
     * @param name Block name
     * @param block Block component
     */
    registerBlock(name, blockComponent) {
        this.blocks[name] = blockComponent;
    },
    /**
     * Registers a new group component
     *
     * @param name Group name
     * @param groupComponent Group component
     */
    registerGroup(name, groupComponent) {
        this.groups[name] = groupComponent;
    }
};
